import {createContext} from "react";
import {UserAuthorizationContextValue} from "./UserAuthorizationContextValue";

export const UserAuthorizationContext =
  createContext<UserAuthorizationContextValue>({
    isUserAuthorized: () => false
  });
